import i18next from "i18next"

// NOTE: Download the official badges here: https://partnermarketinghub.withgoogle.com/brands/google-play/visual-identity/badge-guidelines/?folder=65627

export default async function getGooglePlayBadge(): Promise<string> {
  const language = i18next.language.split("-")[0]

  try {
    const module = (await import(
      `../assets/google_play_badges/google_play_badge_${language}.png`
    )) as { default: string }

    return module.default
  } catch {
    const module =
      await import("../assets/google_play_badges/google_play_badge_en.png")

    return module.default
  }
}
